import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { InputFieldPropertiesEffects } from './effects/input-field-properties.effects';
import { INPUT_FIELD_PROPERTIES_FEATURE_KEY } from './input-field-properties-collection.state';
import { inputFieldPropertiesReducer } from './reducers/input-field-properties.reducer';
import { selectInputFieldProperties } from './selectors/input-field-properties.selector';

/**
 * Registers the input-field-properties feature slice. `InputFieldPropertiesNgrxService.init()`
 * dispatches `initInputFieldProperties`; `InputFieldPropertiesEffects` loads the data from the
 * backend and dispatches `inputFieldPropertiesLoaded`, then mirrors the slice to the generic
 * persistence layer, which caches it in the concurrency store so the properties are available
 * offline. The backend stays the source of truth (see the effect).
 */
@NgModule({
    imports: [
        StoreModule.forFeature(INPUT_FIELD_PROPERTIES_FEATURE_KEY, inputFieldPropertiesReducer),
        EffectsModule.forFeature([InputFieldPropertiesEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: INPUT_FIELD_PROPERTIES_FEATURE_KEY,
                persistSelector: selectInputFieldProperties,
                localOnly: true,
            },
        },
    ],
})
export class InputFieldPropertiesStoreModule {}
